import { FC } from 'react';
import { Paper, Table, TableBody, TableContainer } from '@mui/material';
import { YearlyTaxReportsHeader } from './YearlyTaxReportsHeader';

interface Props {
  children: JSX.Element | JSX.Element[] | string | undefined | null;
  emptyElement: JSX.Element | JSX.Element[] | string | undefined | null;
}

export const YearlyReportsTable: FC<Props> = ({ children, emptyElement }) => {
  const hasRows = Array.isArray(children) && children.length > 0;

  return (
    <Paper>
      <TableContainer>
        <Table sx={{ minWidth: 450 }} aria-label="simple table">
          <YearlyTaxReportsHeader />
          {hasRows && <TableBody>{children}</TableBody>}
        </Table>
        {!hasRows && emptyElement}
      </TableContainer>
    </Paper>
  );
};
